import * as localforage from "localforage";
import { utilityFunction } from "./Wrapper";

const storage = {};

export const getStorage = (name = "default") =>
  utilityFunction(() => {
    return storage[name];
  });

export const createStorage = (options) =>
  utilityFunction(() => {
    return localforage.createInstance(options);
  });

export const removeStorage = (options) =>
  utilityFunction(() => {
    return localforage.dropInstance(options);
  });

export const initStorage = (organizationId) =>
  utilityFunction(() => {
    if (organizationId) {
      storage.default = localforage.createInstance({
        name: `organization_${organizationId}`,
      });
    } else {
      storage.default = localforage.createInstance({ name: "optix" });
    }
  });

const sessionStorageInstances = {};

export const getSessionStorage = (name = "default") =>
  utilityFunction(() => {
    const key = sessionStorageInstances[name] || name;
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  });

export const createSessionStorage = (options) =>
  utilityFunction(() => {
    const { name, data } = options;
    if (!name) throw new Error("Session storage name is required");
    sessionStorageInstances[name] = name;
    sessionStorage.setItem(name, JSON.stringify(data || {}));
    return true;
  });

export const removeSessionStorage = (options) =>
  utilityFunction(() => {
    const { name } = options;
    if (!name) throw new Error("Session storage name is required to remove");
    const key = sessionStorageInstances[name] || name;
    sessionStorage.removeItem(key);
    delete sessionStorageInstances[name];
    return true;
  });

export const initSessionStorage = (organizationId) =>
  utilityFunction(() => {
    const name = organizationId ? `organization_${organizationId}` : "optix";
    sessionStorageInstances.default = name;
    if (!sessionStorage.getItem(name)) {
      sessionStorage.setItem(name, JSON.stringify({}));
    }
    return name;
  });
